import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container"];

  connect() {
    this.currentIndex = 0;
    this.items = this.containerTarget.children;
    this.totalItems = this.items.length;

    // Show only the first item initially
    this.showItem(0);
  }

  next() {
    if (this.currentIndex < this.totalItems - 1) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0; // Loop back to first
    }
    this.showItem(this.currentIndex);
  }

  previous() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = this.totalItems - 1; // Loop to last
    }
    this.showItem(this.currentIndex);
  }

  showItem(index) {
    // Hide all items
    Array.from(this.items).forEach((item, i) => {
      if (i === index) {
        item.classList.remove("hidden");
      } else {
        item.classList.add("hidden");
      }
    });

    this.currentIndex = index;
  }
}
